import {
  FindTenantsRequest,
  RadiusID,
  SearchView,
  SurfaceMinimumID,
} from '@kamernet/core/ApiClient/Kamernet';

import { TenantsSearchAllFilters } from '../types';

export function mapAllFiltersToFindTenantsRequest(
  allFiltersOriginal: TenantsSearchAllFilters,
): FindTenantsRequest {
  const allFilters = JSON.parse(
    JSON.stringify(allFiltersOriginal),
  ) as TenantsSearchAllFilters;

  return {
    location:
      allFilters.cityName && allFilters.citySlug
        ? {
            name: allFilters.cityName,
            cityName: allFilters.cityName,
            citySlug: allFilters.citySlug,
          }
        : null,
    listingTypeIDs: [],
    maxRentalPriceID: allFilters.maxRent,
    surfaceMinimumID: allFilters.minSize || SurfaceMinimumID.M6,
    pageNo: allFilters.pageNo,
    suitableForGenderIDs: allFilters.suitableForGenders,
    furnishings: allFilters.furnishings,
    availabilityPeriods: allFilters.availabilityPeriods,
    suitableForNumberOfPersonsID: allFilters.suitableForNumberOfPersons || null,
    suitableForMinAge: allFilters.suitableForAgeRange[0] || null,
    suitableForMaxAge: allFilters.suitableForAgeRange[1] || null,
    suitableForStatusIDs: allFilters.suitableForWorkStatuses,
    isSmokingInsideAllowed: allFilters.isSmokingInsideAllowed || null,
    isPetsInsideAllowed: allFilters.isPetsInsideAllowed || null,
    roommateMaxNumberID: allFilters.roommateNumberMax || null,
    roommateGenderIDs: allFilters.roommateGenders,
    rowsPerPage: allFilters.tenantsPerPage,
    tenantsWithImageOnly: allFilters.tenantsWithImageOnly,
    radiusID: RadiusID.Km5,
    listingSortOptionID: null,
    availableFromDate: null,
    onlyFavorite: allFilters.searchView === SearchView.Favorite,
  } satisfies FindTenantsRequest;
}
